module.exports = __webpack_public_path__ + "img/IMG_8673_L_Wood_MockedUp.37b0b2c5.jpg";